/* eslint-disable default-param-last */
import { SHOW_INVOICE_DETAILS } from 'actionTypes/invoiceDetailsActionTypes';

const initialState = {
  status: false,
  selectedInvoice: null,
};

const invoiceDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_INVOICE_DETAILS:
      return {
        ...state,
        status: action.payload.status,
        selectedInvoice: action.payload.selectedInvoice,
      };
    default:
      return state;
  }
};

export default invoiceDetailsReducer;
